import { GetAllAction } from "./utils/utils";

// src/access.ts
export default function access(initialState: {
  currentUser?: any;
  menuList: any;
}) {
  const { currentUser, menuList } = initialState || {};
  return {
    canAdmin: currentUser?.sessionid !== null,
    normalRouteFilter: (route: any) => {
      const menuListNew = JSON.parse(JSON.stringify(menuList || {}));
      const names = GetAllAction(menuListNew?.data, []);

      const result = names?.filter(
        (item: { path: any; name: any }) => item.path == route.path
      );
      // if (result?.length == 0)
      // 	console.log(route, names, result);
      return result?.length > 0;
    },
  };
}
